import styled from 'styled-components';

import { BlackBookLoadingPageLogo } from './assets';

export const Root = styled.div`
  height: 100%;
`;

export const LogoContainer = styled.div`
  bottom: 0;
  display: flex;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  background-color: ${({ theme }) => theme.colors.neutrals.c800};
`;

export const Logo = styled(BlackBookLoadingPageLogo)`
  margin: auto;
`;
